import { HTTP } from '@util/http-p'

class SpecModel extends HTTP {
    get_list(data) {
        return this.request({
            url: 'apiadmin/spec/get_list',
            data: data
        })
    }

    isshow(data) {
        return this.request({
            url: 'apiadmin/spec/isshow',
            data: {
                data: data,
                user_token: localStorage.user_token
            },
            method: 'POST',
        })
    }

    post(data) {
        return this.request({
            url: 'apiadmin/spec/post',
            data: data,
            method: 'POST',
        })
    }

    delete(data) {
        return this.request({
            url: 'apiadmin/spec/spec_delete',
            data: {
                data: data,
                user_token: localStorage.user_token
            },
            method: 'POST',
        })
    }

}

export { SpecModel }